export default __webpack_public_path__ + "static/media/bottom-dotted-border.5b60dad6.svg";